import type { ComponentProps } from "react";
import type { CopilotChatAssistantMessage } from "@copilotkit/react-core/v2";

type MarkdownRendererProps = Partial<ComponentProps<typeof CopilotChatAssistantMessage.MarkdownRenderer>>;
type MarkdownComponents = NonNullable<MarkdownRendererProps["components"]>;

// Compact spacing for the narrow side panel, and lists with a hanging indent (wrapped lines align with the text,
// not the bullet). CopilotKit's prose wrapper and Streamdown's `list-inside` defaults are roomier.
const components: MarkdownComponents = {
  p: ({ children }) => <p className="my-2">{children}</p>,
  ul: ({ children }) => <ul className="my-2 list-disc pl-5">{children}</ul>,
  ol: ({ children, start }) => <ol start={start} className="my-2 list-decimal pl-5">{children}</ol>,
  li: ({ children }) => <li className="my-1 pl-0.5 marker:text-muted-foreground">{children}</li>,
};

/**
 * How the copilot's replies render: CopilotKit's markdown renderer (Streamdown) at the app's body text size
 * (text-base = 14px in globals.css; CopilotKit's prose wrapper defaults to 16px),
 * with compact lists, and no copy/download toolbar on tables.
 */
export const COPILOT_MARKDOWN: MarkdownRendererProps = {
  className: "text-base",
  components,
  controls: { table: false },
};
